import { render } from "./Routes.vue?vue&type=template&id=51feb5f8&scoped=true&bindings={\"routes\":\"data\",\"confirmRouteDelete\":\"data\",\"config\":\"options\",\"activeWorkspaceId\":\"options\",\"routeEditings\":\"options\",\"getRouteEditing\":\"options\",\"getRoutes\":\"options\",\"openAddNewRoute\":\"options\",\"openEditRoute\":\"options\",\"deleteRoute\":\"options\"}"
import script from "./Routes.vue?vue&type=script&lang=js"
export * from "./Routes.vue?vue&type=script&lang=js"

import "./Routes.vue?vue&type=style&index=0&id=51feb5f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51feb5f8"

export default script